import { loadCookie } from '@vimeo/core/libs/cookies';

/**
 * Get password hash stored in browser cookie
 */
export const getPasswordHashFromCookie = (clipId: string | number) => {
  const name = `${clipId}_password`;
  return loadCookie(name);
};
